import { nanoid } from 'nanoid';

export const debounce = (func, delay = 600, immediate = false) => {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, delay);
    if (callNow) func.apply(context, args);
  };
};

export const getUniqueID = () => {
  return nanoid();
};

/* 
  1 WORD: FIRST LETTER (PEREZ -> P)
  2 WORDS: FIRST + LAST (JUAN PEREZ -> JP)
  3 WORDS: FIRST + THIRD (JUAN PEREZ GOMEZ -> JG)
  4+ WORDS: FIRST + THIRD (JUAN CARLOS PEREZ GOMEZ -> JP)
*/
export const getNameInitials = (name) => {
  const words = name?.trim().split(/\s+/).filter(Boolean) ?? [];
  if (!words.length) return '';
  if (words.length === 1) return words[0][0].toUpperCase();
  const second = words.length === 2 ? words[1] : words[2];
  return (words[0][0] + second[0]).toUpperCase();
};

export const getColorHsl = (seed = null) => {
  const hue =
    seed != null
      ? Math.abs(
          String(seed)
            .split('')
            .reduce((acc, ch) => ch.charCodeAt(0) + ((acc << 5) - acc), 0)
        ) % 360
      : Math.floor(Math.random() * 360);

  return `hsl(${hue}, 65%, 40%)`;
};

export const capitalizeString = (str) => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

// LOWERCASE, NO ACCENTS, TRIMMED
export const normalizeText = (text) =>
  (text ?? '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
